// extracted by mini-css-extract-plugin
export var education = "education-module--education--08lxc";
export var educationContainer = "education-module--education-container--BZ8bC";
export var educationImage = "education-module--education-image--IA63J";
export var educationSubtitle = "education-module--education-subtitle--UEn5q";
export var educationTitle = "education-module--education-title--F8UIn";